import styled from "styled-components";

interface EntityBadgeContainerProps {
  useAsActionButton?: boolean;
  alignItems?: string;
  showLabel?: boolean;
  hideBackground?: boolean;
}

interface EntityBadgeIconWrapperProps {
  /** Already resolved off the theme by EntityBadge. */
  bgColor?: string;
  padding?: string;
  showLabel?: boolean;
  hideBackground?: boolean;
  showBorder?: boolean;
  borderColor?: string;
  borderRadius?: string;
}

export const Container = styled.div<EntityBadgeContainerProps>`
  display: ${({ showLabel, hideBackground }) =>
    showLabel || hideBackground ? "block" : "flex"};
  gap: 10px;
  align-items: ${({ alignItems }) => alignItems || "center"};
  cursor: ${({ useAsActionButton }) =>
    useAsActionButton ? "pointer" : "default"};
  text-overflow: nowrap;
  white-space: nowrap;
  max-width: 100%;
`;

export const IconWrapper = styled.div<EntityBadgeIconWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, bgColor, hideBackground }) =>
    hideBackground
      ? theme.colors.ui.overlay.transparent
      : bgColor ?? theme.colors.domainSpecific.badgeTypes.info.background};
  padding: ${({ padding, hideBackground }) =>
    hideBackground ? "0px" : padding};
  border-radius: ${({ borderRadius }) => borderRadius || "40px"};
  width: ${({ showLabel, hideBackground }) =>
    showLabel || hideBackground ? "fit-content" : "24px"};
  max-width: ${({ showLabel }) => (showLabel ? "240px" : "none")};
  gap: ${({ showLabel }) => (showLabel ? "4px" : "0px")};
  height: ${({ showLabel }) => (showLabel ? "auto" : "24px")};
  border: ${({ theme, showBorder, borderColor }) =>
    showBorder
      ? `1.5px solid ${borderColor ?? theme.colors.ui.overlay.transparent}`
      : "none"};
  overflow: hidden;
`;

export const DropdownWrapper = styled.div`
  position: relative;
  display: block;
`;

export const DropdownButton = styled.button<{
  selectedOption?: "all" | "Personal" | string;
}>`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
  padding: ${({ selectedOption }) =>
    selectedOption === "all" ? "0px 12px" : "0px"};
`;

export const DropdownItem = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 12px;
  background-color: ${({ theme }) => theme.colors.ui.background.raised};
  min-width: 250px;
  width: 100%;
  &:active {
    background-color: ${({ theme }) => theme.colors.ui.background.pageSubtle};
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.ui.background.pageSubtle};
    transition: background-color 0.5s ease;
  }
`;

export const DropdownItemsContainer = styled.div<{
  offsetRight?: string;
  menuAlignedFrom?: "right" | "left";
}>`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.ui.background.raised};
  max-height: 320px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.ui.border.default};
  position: absolute;
  top: 48px;
  min-width: 250px;
  ${(props) => (props.menuAlignedFrom === "left" ? "left: 0;" : "right: 0;")}
  box-shadow: ${({ theme }) => theme.elevation.low};
  z-index: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  gap: 12px;
`;
